module.exports = __webpack_public_path__ + "influicons.c1fbb764722543079e6eed996ce8e218.ttf";